<div class="row justify-content-center" *ngIf="caseservice.case && caseservice.case.settings.allowEditBasicData">
    <div class="col-lg-2" [hidden]="isEdit">
        <span class="btn btn-primary w-100" (click)="editMode()">
            <app-feather-icons [icon]="'unlock'"></app-feather-icons>
            {{'EditReport'|translate}}
        </span>
    </div>
    <div class="col-lg-2" [hidden]="!isEdit">
        <span class="btn btn-danger w-100" (click)="showMode()">
            <app-feather-icons [icon]="'lock'"></app-feather-icons>
            {{'CancelEdit'|translate}}
        </span>
    </div>
</div>
<div *ngIf="!isEdit" class="col-lg-12 row p-4">
    <div class="card p-3">
        <h5 class=" mb-0 text-secondary"> {{'ReportInformation' | translate}}</h5>
        <hr class="mb-3" />
        <div class="row">
            <div class="form-group mt-3 row">
                <div class="col-lg-4 mt-3">
                    <div class="divformlabel">
                        <label for="ReportDate">{{'ReportDate' | translate}}</label>
                    </div>
                    <input type="text" [value]="reportDate| toDateLarge " class="form-control"
                    readonly />
                </div>
                <div class="col-lg-4 mt-3">
                    <label for="number">{{'ReportNumber' | translate}}</label>
                    <input type="text" class="form-control" [(ngModel)]="reportNumber"   readonly />
                </div>
                <div class="col-lg-4 mt-3">
                    <label>{{'ReportType' | translate}}</label>
                    <!-- <ng-select></ng-select> -->
                    <ng-select [items]="reporttypesList" [(ngModel)]="reportTypeId" [multiple]="false" [clearable]="false"
                    bindLabel="text" bindValue="id" [readonly]="true"></ng-select>
  
                </div>
            </div>
            <div class="form-group row">
                <div class="col-lg-4  mt-3">
                    <label for="" >{{'ReporterAddress' | translate}}</label>
                    <input type="text" class="form-control" [(ngModel)]="address"   readonly/>

                </div>
                <div class="col-lg-4 mt-3">
                    <label>{{'ReporterNationalityType' | translate}}</label>
                    <ng-select [items]="reporterNationalTypeList" [(ngModel)]="reporterNationalTypeId" [multiple]="false" [clearable]="false"
                    bindLabel="text" bindValue="id" [readonly]="true"></ng-select>
                </div>
                
                <div class="col-lg-4  mt-3">
                    <label for="">{{'Nationality' | translate}}</label>
                    <ng-select id="Nationality"
                    required
                    #Nationality="ngModel"
                    class="form-control-select"
                    [(ngModel)]="reporterNationalityId"
                    [ngModelOptions]="{ standalone: true }"
                    placeholder="{{ 'Nationality' | translate }}"
                    [readonly]="true"  >
    
             <ng-option *ngFor="let na of NationalityList" [value]="na.id">
                 <i class="flag-icon flag-icon-{{na.more}}"></i>
                 <span>{{na.text}} </span>
             </ng-option>
         </ng-select>
                </div>
            
            </div>

            <div class="form-group row">
                <div class="col-lg-4 mt-3">
                    <label for="RelationshipWithTheFacility">{{'RelationshipWithTheFacility' | translate}}</label>
                    <ng-select [items]="reporterRelationList" [(ngModel)]="reporterRelationId" [multiple]="false" [clearable]="false"
                    bindLabel="text" bindValue="id" [readonly]="true"></ng-select>
                </div>

                <div class="col-lg-4  mt-3">
                    <label for="CRType" >{{'ReporterName' | translate}}</label>
                    <input type="text" class="form-control" [(ngModel)]="reporterName" readonly />

                </div>
                <div class="col-lg-4 mt-3">
                     <div class="divformlabel">
                        <label>
                          {{ "ReporterNationality" | translate }}
                        </label>
                        <!-- <span
                          *ngIf="reporterNationalId.invalid"
                          class="alert"
                          style="
                            color: red;
                            white-space: nowrap;
                            line-height: 0;
                            padding: 0;
                            margin-top: 8px;
                          "
                        >
                          <div *ngIf="reporterNationalId.errors?.required">
                            *
                          </div>
                        </span>
                        <span
                          *ngIf="reporterNationalId.invalid"
                          class="alert"
                          style="
                            color: red;
                            white-space: nowrap;
                            line-height: 0;
                            padding: 0;
                            margin-top: 8px;
                          "
                        >
                          <div *ngIf="reporterNationalId.errors?.minlength">
                            {{"IdentityNumberMustBe10Number" | translate}}
                          </div>
                        </span> -->
                      </div>
                    <input (keypress)="numberOnly($event)"  type="text" class="form-control" [(ngModel)]="reporterNationalId"  readonly  />

                </div>
            </div>

            <div class="form-group  row">

                <div class="col-lg-4 mt-3">
                    <div class="divformlabel">
                        <label for="">{{'MobileNumber' | translate}} </label>
                    </div>
                    <input type="text" class="form-control" [(ngModel)]="reporterMobileNumber" readonly />

                </div>
                <div class="col-lg-4 mt-3">
                    <div class="divformlabel">
                        <label for="Capital">{{'MobileNumber' | translate}}  2</label>
                    </div>

                    <input type="text" class="form-control" [(ngModel)]="reporterMobileNumber2" readonly />

                </div>    
            </div>
            <div class="form-group  row">
                <div class="col-lg-12  mt-3">
                    <label for="ReportDetails" >{{'ReportDetails' | translate}}</label>
                    <textarea class="form-control" type="text"
                    name="ReportDetails"
                    placeholder="{{'ReportDetails' | translate}}"
                    [(ngModel)]="reportDetails" #ReportDetails="ngModel" readonly ></textarea>
                
                </div>
            </div>
        </div>
        
       
    </div>



</div>
<div *ngIf="isEdit" class="col-lg-12 row p-4">
    <div class="card p-3">
        <h5 class=" mb-0 text-secondary"> {{'ReportInformation' | translate}}</h5>
        <hr class="mb-3" />
        <div class="row">
            <div class="form-group mt-3 row">
                <div class="col-lg-4 mt-3">
                    <div class="divformlabel">
                        <label for="ReportDate">{{'ReportDate' | translate}}</label>
                    </div>
                    <datepicker [(maxHijri)]="currentDate" [(maxGreg)]="currentDate"  [(selectedDate)]="editedDate" (selectedDateChange)="SelectedDateChange($event)" [selectedDateType]="2"></datepicker>
                  
                </div>
                <div class="col-lg-4 mt-3">
                    <label for="number">{{'ReportNumber' | translate}}</label>
                    <input type="text" (keypress)="numberOnly($event)" class="form-control" [(ngModel)]="reportNumber"    />
                </div>
                <div class="col-lg-4 mt-3">
                    <label>{{'ReportType' | translate}}</label>
                    <!-- <ng-select></ng-select> -->
                    <ng-select [items]="reporttypesList" [(ngModel)]="reportTypeId" [multiple]="false" [clearable]="false"
                    bindLabel="text" bindValue="id" ></ng-select>
  
                </div>
            </div>
            <div class="form-group row">
                <div class="col-lg-4  mt-3">
                    <label for="" >{{'ReporterAddress' | translate}}</label>
                    <input type="text" class="form-control" [(ngModel)]="address"      />

                </div>
                <div class="col-lg-4 mt-3">
                    <label>{{'ReporterNationalityType' | translate}}</label>
                    <!-- <div class="divformlabel">
                    
                    <span
                    *ngIf="identityTypes.invalid"
                    class="alert"
                    style="
                      color: red;
                      white-space: nowrap;
                      line-height: 0;
                      padding: 0;
                      margin-top: 8px;
                    "
                  >
                    <div *ngIf="identityTypes.errors?.required">*</div></span>
                  </div> -->
                    <ng-select id="identityTypes"
                    #identityTypes="ngModel" [items]="reporterNationalTypeList" [(ngModel)]="reporterNationalTypeId" [multiple]="false" [clearable]="false"
                    bindLabel="text" bindValue="id" ></ng-select>
                </div>
                
                <div class="col-lg-4  mt-3">
                    <label for="">{{'Nationality' | translate}}</label>
                    <ng-select id="Nationality"
                    required
                    #Nationality="ngModel"
                    class="form-control-select"
                    [(ngModel)]="reporterNationalityId"
                    [ngModelOptions]="{ standalone: true }"
                    placeholder="{{ 'Nationality' | translate }}"  
                    >

             <ng-option *ngFor="let na of NationalityList" [value]="na.id">
                 <i class="flag-icon flag-icon-{{na.more}}"></i>
                 <span>{{na.text}} </span>
             </ng-option>
         </ng-select>
                </div>
            </div>

            <div class="form-group row">
                <div class="col-lg-4 mt-3">
                    <label for="RelationshipWithTheFacility">{{'RelationshipWithTheFacility' | translate}}</label>
                    <ng-select [items]="reporterRelationList" [(ngModel)]="reporterRelationId" [multiple]="false" [clearable]="false"
                    bindLabel="text" bindValue="id" ></ng-select>
                </div>

                <div class="col-lg-4  mt-3">
                    <label for="CRType" >{{'ReporterName' | translate}}</label>
                    <input type="text" class="form-control" [(ngModel)]="reporterName"    />

                </div>
                <div class="col-lg-4 mt-3">
                    <div class="divformlabel">
                        <label>
                          {{ "ReporterNationality" | translate }}
                        </label>
                        <!-- <span
                          *ngIf="ReporterNationality.invalid"
                          class="alert"
                          style="
                            color: red;
                            white-space: nowrap;
                            line-height: 0;
                            padding: 0;
                            margin-top: 8px;
                          "
                        >
                          <div *ngIf="ReporterNationality.errors?.required">
                            *
                          </div>
                        </span>
                        <span
                          *ngIf="ReporterNationality.invalid"
                          class="alert"
                          style="
                            color: red;
                            white-space: nowrap;
                            line-height: 0;
                            padding: 0;
                            margin-top: 8px;
                          "
                        >
                          <div *ngIf="ReporterNationality.errors?.minlength">
                            {{"IdentityNumberMustBe10Number" | translate}}
                          </div>
                        </span> -->
                      </div>
                      <input 
                      required
                      #ReporterNationality="ngModel"
                      minlength="10"
                      maxlength="10"
                      name="ReporterNationality"
                      id="ReporterNationality"
                      type="text" class="form-control" (keypress)="numberOnly($event)" [(ngModel)]="reporterNationalId" />

                </div>
            </div>

            <div class="form-group  row">

                <div class="col-lg-4 mt-3">
                  <div class="divformlabel">
                        <label for="mobile">{{'MobileNumber'|translate}} </label>
                          <span *ngIf="Mobile.invalid" class="alert" style="color: red; white-space: nowrap;line-height: 0; padding: 0; margin-top: 8px;">
                              <!-- <div *ngIf="Mobile.errors?.required">
                                  *
                              </div> -->
                              <div *ngIf="Mobile.errors?.pattern">
                                  {{'ThisMobileIsInvalid' | translate}}
                              </div>
                          </span>
                        </div>
                        <input required   #Mobile="ngModel" pattern="^(009665|9665|\+9665|05|5)(5|0|3|6|4|9|1|8|7)([0-9]{7})$"  placeholder="{{'MobileNumber'|translate}}" type="text" [(ngModel)]="reporterMobileNumber" [ngModelOptions]="{standalone: true}" class="form-control" name="mobile" id="mobile" [ngModelOptions]="{standalone: true}" >
                    
                </div>
                <div class="col-lg-4 mt-3">
                    <div class="divformlabel">
                        <label for="Mobile2">{{'MobileNumber'|translate}} 2</label>
                          <span *ngIf="Mobile2.invalid" class="alert" style="color: red; white-space: nowrap;line-height: 0; padding: 0; margin-top: 8px;">
                              <!-- <div *ngIf="Mobile2.errors?.required">
                                  *
                              </div> -->
                              <div *ngIf="Mobile2.errors?.pattern">
                                  {{'ThisMobileIsInvalid' | translate}}
                              </div>
                          </span>
                        </div>
                        <input required   #Mobile2="ngModel" pattern="^(009665|9665|\+9665|05|5)(5|0|3|6|4|9|1|8|7)([0-9]{7})$"  placeholder="{{'MobileNumber'|translate}}" type="text" [(ngModel)]="reporterMobileNumber2" [ngModelOptions]="{standalone: true}" class="form-control" name="Mobile2" id="Mobile2" [ngModelOptions]="{standalone: true}" >
                 
                </div>    
            </div>
            <div class="form-group  row">
                <div class="col-lg-12  mt-3">
                    <label for="ReportDetails" >{{'ReportDetails' | translate}}</label>
                    <span *ngIf="ReportDetails.invalid" class="alert" style="
                    color: red;
                    white-space: nowrap;
                    line-height: 0;
                    padding: 0;
                    margin-top: 8px;
                  ">
                      <span *ngIf="ReportDetails.errors?.required">*</span>
                  </span>
                    <textarea class="form-control" type="text"
                    name="ReportDetails"
                    placeholder="{{'ReportDetails' | translate}}"
                    [(ngModel)]="reportDetails" #ReportDetails="ngModel" required></textarea>
                </div>
            </div>
        </div>
        
       
    </div>


    <div class="col-lg-3 m-auto">
        <button *ngIf="caseservice.case && caseservice.case.settings.allowEditBasicData"
        [disabled]="ReportDetails.invalid "  (click)="SaveCaseReport();"
                class="btn btn-primary mt-3"
                style="width: 100%"
                type="button">
            {{ "Save" | translate }}
        </button>
    </div>
</div>